import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '@dbk-legacy/format';
import { View } from '@dbk/ui-react-utils';
import { Large } from '@dbk/ui-text';
import { EDELIVERY_CATEGORY_ID, EDELIVERY, SELECTED_RANGE, REPORT_PORTFOLIO_ID } from '../constants';

class ReportRMEmptyData extends PureComponent {


  getFormattedMessage = () => {
    // const { i18n: { messages }, reports: { selectedCategoryId, selectedReportDetailsDateRange } } = this.props;
    // let selectedCategoryName = this.getCategoryName(selectedCategoryId);
    // let duration = this.getDuration(selectedReportDetailsDateRange);

    const {
      reports: { selectedReportDetailsDateRange }, i18n: {
        messages
      }
    } = this.props;

    const selectedCategoryName = messages['app.chedelivery.reports.receivedFromRM_category'];
    const duration = this.getDuration(selectedReportDetailsDateRange);

    return (<FormattedMessage
      id="app.chedelivery.reports.emptymsg"
      values={{ selectedCategoryName, duration }}
    />);
  }

  /**
   * function: to get category name by selected category id
   */
  getCategoryName = (selectedCategoryId) => {
    const { i18n: { messages } } = this.props;
    let selectedCategoryName = "";
    const categoryId = parseInt(selectedCategoryId, 10);

    switch (categoryId) {
      case EDELIVERY.UNREAD_CATEGORY_ID:
        selectedCategoryName = messages['app.chedelivery.reports.unreadDocuments'];
        break;
      default:
        selectedCategoryName = messages['app.chedelivery.reports.unreadDocuments'];
        break;
    }
    return selectedCategoryName;
  }

  /**
   * function: to get duration on selection of Tabs
   */
  getDuration = (duration) => {
    const { i18n: { messages } } = this.props;
    let selectedDuration = "";
    switch (duration) {
      case SELECTED_RANGE.LAST_WEEK:
        selectedDuration = messages['app.chedelivery.reports.duration.lastweek'];
        break;
      case SELECTED_RANGE.LAST_MONTH:
        selectedDuration = messages['app.chedelivery.reports.duration.lastmonth'];
        break;
      case SELECTED_RANGE.LAST_90_DAYS:
        selectedDuration = messages['app.chedelivery.reports.duration.last90days'];
        break;
      case SELECTED_RANGE.CUSTOM:
        selectedDuration = messages['app.chedelivery.reports.duration.dateRange'];
        break;
      default:
        selectedDuration = messages['app.chedelivery.reports.duration.last90days'];
        break;
    }
    return selectedDuration;
  }

  render() {
    const { reports: { showSpinner } } = this.props;
    return (
      showSpinner === false && <div style={{ display: 'table', width: '100%' }}>
        <Large
          tabIndex={0}
          className="mssgeforNoDoc"
          secondary>
          {this.getFormattedMessage()}
        </Large>
      </div>
    );
  }
}

ReportRMEmptyData.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  reports: PropTypes.shape({
    user: { selectedPortfolioId: true },
    selectedCategoryId: PropTypes.string,
    selectedReportDetailsDateRange: PropTypes.string,

  })
}

ReportRMEmptyData.defaultProps = {
  i18n: {},
  reports: {}
};


export default createContainer(
  {
    $queries: {
      i18n: {
        messages: true,
      },
      reports: {
        showSpinner: true,
        user: { selectedPortfolioId: true },
        selectedReportDetailsDateRange: true,
        selectedCategoryId: true,
        showUnreadOnlyChecked: true,
      }
    },
  },

)(ReportRMEmptyData);
